import { createModeratorApiClient } from '../utils/apiClient';

const mod = createModeratorApiClient();

export const statsApi = {
  /**
   * Overview counts for the moderator dashboard stat cards.
   * @param {import('axios').AxiosRequestConfig} [config]
   * @returns {Promise<import('axios').AxiosResponse<import('../types/api').StatsOverview>>}
   */
  overview: (config) => mod.get('/stats/overview', config),
};
